import emailTemplateHtml from "@/components/CustomComponents/ContactUsForm/emailTemplate"
import emailAFriendTemplateHtml from "@/components/CustomComponents/EmailAFriend/emailTemplate"
import {
  BRAND_REGISTRATION_SUBMIT_API,
  CONTACT_NOTIFICATION_FORM_SUBMIT_API,
} from "@/constants"
import { apim } from "@/constants/api"
import { removeQuotesFromString } from "@/utils/footerUtils"

// salesforce api used in brand regsitration
export const formSubmission = async requestBody => {
  try {
    let newObj = {}
    for (let i in requestBody) {
      newObj[i] = removeQuotesFromString(requestBody[i])
    }
    const payload = {
      items: [
        {
          "Customer Email": newObj?.customerEmail,
          "Customer Name": newObj?.customerName,
          "Customer Phone Number": newObj?.phoneNumber,
          "Project Type": newObj?.projectType?.[0],
          "Project As": newObj?.projectAs,
          "Range Budget": newObj?.budgetRange,
          "Timeline Project": newObj?.timelineProject,
          "Project Location": newObj?.projectLocation,
          "Kohler Privacy": newObj?.agreeTerms,
          "News and Email OptIn": newObj?.agreeMarketing,
        },
      ],
    }
    const { data } = await apim.post(
      BRAND_REGISTRATION_SUBMIT_API,
      JSON.stringify(payload)
    )
    return data?.requestId || ""
  } catch (err) {
    console.log(err)
  }
}

// this is an internal api - written in pages/api - calling google captcha directly.
export const verifyForm = async token => {
  try {
    const res = await fetch("/api/verify", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        g_recaptcha_response: token,
      }),
    })

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`)
    }

    const verifyData = await res.json()

    return {
      success: true,
      data: verifyData?.data || {},
    }
  } catch (error) {
    console.error("verifyForm error:", error)

    return {
      success: false,
      error: error.message || "Something went wrong",
    }
  }
}

// used for contact-form submission
export const contactFormNotificationAPI = async ({
  values,
  filteredContactFormConfigurations,
}) => {
  try {
    let newObj = {}
    for (let i in values) {
      newObj[i] = removeQuotesFromString(values[i])
    }

    const emailTemplate = emailTemplateHtml({ formValues: newObj })
    const notificationObj = {
      mailText: emailTemplate,
      recipient: newObj.email,
      subject: "Customer Enquiry",
      from: "noreply@kohler.com",
    }
    const storeRecipient =
      filteredContactFormConfigurations?.[newObj.request_type] || ""
    const storeNotificationObj = {
      mailText: emailTemplate,
      recipient: storeRecipient,
      subject: "Customer Enquiry - Contact Us Form",
      from: "noreply@kohler.com",
    }
    const { data = {} } = await apim.post(
      CONTACT_NOTIFICATION_FORM_SUBMIT_API,
      JSON.stringify(notificationObj)
    )
    if (storeRecipient) {
      try {
        await apim.post(
          CONTACT_NOTIFICATION_FORM_SUBMIT_API,
          JSON.stringify(storeNotificationObj)
        )
      } catch (storeErr) {
        console.log("Store notification failed:", storeErr)
      }
    }
    return data || {}
  } catch (err) {
    console.log(err)
  }
}

// used for email-a-friend form submission
export const emailAFriendNotificationAPI = async requestBody => {
  try {
    let newObj = {}
    for (let i in requestBody) {
      newObj[i] = removeQuotesFromString(requestBody[i])
    }

    const emailTemplate = emailAFriendTemplateHtml({ formValues: newObj })
    const notificationObj = {
      mailText: emailTemplate,
      recipient: `${newObj.recipientsemail}; ${newObj.email}; kohlerasiapacific@kohler.com`,
      subject: "A friend wants to share a Kohler product with you",
      from: "noreply@kohler.com",
    }
    const { data = {} } = await apim.post(
      CONTACT_NOTIFICATION_FORM_SUBMIT_API,
      JSON.stringify(notificationObj)
    )
    return data || {}
  } catch (err) {
    console.log(err)
  }
}
